import { OyResponse } from '../Config/Response';

export type ConnectResponse = OyResponse<string>;

export type ConnectRequest = {
  platform: IntegrationPlatformType;
};

export const PLATFORM_INTEGRATION = {
  ACCURATE: 'ACCURATE',
  JURNAL: 'JURNAL',
  XERO: 'XERO',
} as const;

export type IntegrationPlatformType = keyof typeof PLATFORM_INTEGRATION;

export type IntegrationDatabase = {
  name: string;
  id: string;
  valid: boolean;
};

export type ConnectDatabaseResponse = OyResponse<IntegrationDatabase[]>;

export type ConnectDatabaseRequest = {
  id: string;
  platform: IntegrationPlatformType;
};
